import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl } from 'src/utils/helper'

const StoresSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.stores')}
      </Typography.Title>
      <a href={`${baseUrlShopify}/blogs/stores`}>
        {t('common:footer.stores.all_stores')}
      </a>
      <a href={`${baseUrlShopify}/blogs/stores`}>
        {t('common:footer.stores.book_appointment')}
      </a>
    </Space>
  )
}

export default StoresSection
